import { useState } from 'react'

const useSectionState =  (config, options) => {
    // `onMount` says how a section opens the first time it renders: 'collapse'
    // or 'expand' (the default). It is read once, at mount — it is not the
    // `collapse` that decides whether a hidden element keeps its layout space.
    const formOpen = options.onMount !== 'collapse'

    let sectionExpanded = {}
    config.sections.forEach(
        (section) => {
            const onMount = section.meta.onMount
            const startsCollapsed = onMount === 'collapse'
                || (onMount && typeof onMount === 'object' && onMount[options.mode] === 'collapse')
            sectionExpanded[section.id] = startsCollapsed ? false : formOpen
        }
    )


    const [expanded, setExpanded] = useState(sectionExpanded)

    // Every section to its display — the card form does this on collapseCard.
    const collapseAll = () => setExpanded(prev => Object.fromEntries(Object.keys(prev).map(k => [k, false])))

    const toggleExpanded = (sectionName) => {
        setExpanded(prevState => ({
            ...prevState,
            [sectionName]: !prevState[sectionName] // Toggle the value based on sectionName
        }));
    }

    return {expanded, toggleExpanded, collapseAll}

}

export default useSectionState

